module.exports = __webpack_public_path__ + "static/media/undraw_personal_information_re_vw8a.10b3eefc.svg";